import type { LatestOpenTicket as LatestOpenTicketProto } from '@taxfyle/api-internal/internal/ticket_pb'
import type { JobTicketProps } from '@/features/jobs/tickets/JobTicket'
import { Id } from '@/infra/id'
import { safeTimestampToDate } from '@/utils/grpc-util'

export function mapLatestOpenTicketProtoToProps(
  proto: LatestOpenTicketProto,
  jobId: Id,
): JobTicketProps {
  return {
    id: Id(proto.getId()),
    jobId,
    statusMessage: proto.getStatusMessage()?.getValue() ?? '',
    lastUpdated: safeTimestampToDate(proto.getUpdateTime()),
  }
}
